import styled from "styled-components";

export const SearchFiltersContainer = styled.div``;

export const FilterButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 1rem;

  color: ${({ theme }) => theme.colors.searchPage.inputColor};
  font: 500 0.813rem/1.219rem "Inter";

  padding: 0.875rem 0.75rem !important;
  padding-left: 2.625rem;

  background-color: ${({ theme }) =>
    theme.colors.searchPage.inputBackgroundColor};
  border: 1px solid ${({ theme }) => theme.colors.searchPage.inputBorderColor};

  border-radius: 4px;
  width: 100%;

  transition: all ease-in-out 0.2s;

  :hover {
    background-color: ${({ theme }) =>
      theme.colors.searchPage.inputBackgroundColorHover};
  }

  svg * {
    fill: ${({ theme }) => theme.colors.searchPage.inputColor};
  }
`;
